// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Web = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Web = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Web = _exports.Web = function Web(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.587-8-8-8m6.74 7.386h-2.868c-.104-1.967-.7-3.965-1.725-5.8a6.78 6.78 0 0 1 4.592 5.8m-6.234-6.13c1.267 1.893 2.013 4.035 2.136 6.128h-5.28c.123-2.093.867-4.235 2.134-6.128.166-.013.334-.026.504-.026s.338.015.506.026m-2.651.33C6.83 5.42 6.234 7.419 6.13 9.386H3.263a6.78 6.78 0 0 1 4.592-5.8m-4.592 7.03H6.13c.104 1.965.7 3.963 1.725 5.8a6.78 6.78 0 0 1-4.592-5.8m6.233 6.128C8.23 14.85 7.483 12.71 7.362 10.616h5.28c-.123 2.094-.867 4.235-2.136 6.128a7 7 0 0 1-.504.026c-.17 0-.34-.013-.506-.026m2.651-.33c1.024-1.835 1.621-3.833 1.725-5.8h2.867a6.78 6.78 0 0 1-4.592 5.8"
    }));
  };
});
